import { EncompassFieldTriggerConfig } from 'src/services/loans/types';
import { cn } from 'src/utils/cn';
import { EncompassFieldConditionEditor } from './EncompassFieldConditionEditor';

const defaultConfig: EncompassFieldTriggerConfig = {
  enabled: false,
  conditions: [],
};

export function EncompassFieldTriggerEditor({
  config,
  onChange,
}: Readonly<{
  config: EncompassFieldTriggerConfig | undefined;
  onChange: (next: EncompassFieldTriggerConfig) => void;
}>) {
  const enabled = config?.enabled ?? false;
  const effectiveConfig = config ?? defaultConfig;

  return (
    <div
      className={cn(
        'flex flex-col gap-2 rounded border p-2.5',
        enabled ? 'border-blue-200 bg-blue-50/30' : 'border-gray-200',
      )}
    >
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-700">
            Encompass Field Trigger
          </span>
          <span className="text-[10px] text-gray-500">
            Run this rule only when Encompass fields match
          </span>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          aria-label="Enable Encompass field trigger"
          className={cn(
            'relative inline-flex h-4 w-7 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none',
            enabled ? 'bg-blue-600' : 'bg-gray-200',
          )}
          onClick={() =>
            onChange({
              ...effectiveConfig,
              enabled: !enabled,
              conditions:
                !enabled && effectiveConfig.conditions.length === 0
                  ? [{ field: '', operator: 'and', value: '' }]
                  : effectiveConfig.conditions,
            })
          }
        >
          <span
            aria-hidden="true"
            className={cn(
              'pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
              enabled ? 'translate-x-3' : 'translate-x-0',
            )}
          />
        </button>
      </div>
      {enabled && (
        <div className="border-t border-blue-100 pt-2.5">
          <EncompassFieldConditionEditor
            conditions={effectiveConfig.conditions}
            onChange={(conditions) =>
              onChange({ ...effectiveConfig, conditions })
            }
            idPrefix="rule-encompass-trigger"
            layout="compact"
          />
        </div>
      )}
    </div>
  );
}
